/**
 * UranIA PA — Segmento layout (servizi).
 *
 * Pathless (`id: '_servizi'`): raggruppa le rotte autenticate rivolte a
 * funzionario_adg / beneficiario_ri (e admin, che le vedono ma atterrano
 * altrove — vedi `lib/ruoli.ts`). Unica guardia comune: autenticazione.
 * Le restrizioni di ruolo più strette di una singola rotta (es.
 * `/immersivo`, riservata a chi redige atti) restano dichiarate lì, non
 * qui — vedi `guardia()` in `lib/ruoli.ts` e il file della rotta.
 *
 * Il redirect per anonimi punta a `/login/pa` (destinazione reale oggi).
 * Diventerà `/accedi?returnTo=…` quando la fusione `/login` → `/accedi`
 * (Rilascio A, passo A.4.2) esisterà — vedi `guardiaAutenticato` in
 * `lib/ruoli.ts`.
 *
 * Il redirect "onboarding non completato → /onboarding" previsto dal
 * documento di riordino (§5) resta fuori da questo passo: `/onboarding`
 * (singolare, adattivo per ruolo) non esiste ancora — nasce alla fusione
 * A.4.3. Fino ad allora la guardia onboarding resta dove vive oggi
 * (`useFunzionarioOnboardingStatus` nel componente di `/workspace/mod5` e
 * `/cowork`).
 *
 * Vedi "UranIA PA — Riordino della mappa delle rotte" §3/§5 (2026-09-07),
 * Rilascio A passo A.1.
 */

import { createRoute, Outlet } from '@tanstack/react-router';

import { ruoloCorrente } from '../lib/auth/ruolo-corrente.ts';
import { guardiaAutenticato } from '../lib/ruoli.ts';
import { Route as RootRoute } from './__root.tsx';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  id: '_servizi',
  beforeLoad: () => guardiaAutenticato(ruoloCorrente()),
  component: Outlet,
});
